import { render, staticRenderFns } from "./index.vue?vue&type=template&id=4c1a4054&"
import script from "./index.vue?vue&type=script&lang=js&"
export * from "./index.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/builds/brisk/brisk-frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('4c1a4054')) {
      api.createRecord('4c1a4054', component.options)
    } else {
      api.reload('4c1a4054', component.options)
    }
    module.hot.accept("./index.vue?vue&type=template&id=4c1a4054&", function () {
      api.rerender('4c1a4054', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/app_versions/index.vue"
export default component.exports